const about = resolve => require(['@/page/about/index'], resolve);
export default [
  {
    path: '/about',
    name: 'about',
    component: about,
    meta: {
      title: "关于我们"
    }
  }
]